module.exports = __webpack_public_path__ + "img/receipt27.44c32b2f.png";